import type { ReactElement } from "react"

/**
 * A book with the external-link arrow folded into its own corner, rather than
 * set beside it. At the 20px this ships at, a separate arrow reads as a second
 * object; tucking it into the cover keeps one silhouette.
 *
 * `currentColor` throughout, so it takes the audience's label colour.
 */
export const BookLink = ({ size = 20 }: { readonly size?: number }): ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20 4.5v7" />
    <path d="M5 19.2A2.2 2.2 0 0 1 7.2 17H16" />
    <path d="M7.2 3.5H16v13.5H7.2A2.2 2.2 0 0 1 5 14.8V5.7a2.2 2.2 0 0 1 2.2-2.2z" />
    <polyline points="17.5 7 20 4.5 22.5 7" />
  </svg>
)
